import React from "react";
import "../About/about.scss";
import { Link } from "react-router-dom";
import { AnimatedOnScroll } from "react-animated-css-onscroll";
import AdminFirst from "../../Assets/Images/admin-1.png";
import AdminTrack from "../../Assets/Images/admin-2.png";
import OrderList from "../../Assets/Images/admin-3.png";


const About = () => {
  return (
    <>
      {/* <Header/> */}
      <div className="about-main">
        <div className="common-banner">
          <div className="container">
            <div className="common-head">
              <div className="line-head">
                <p>Who We Are</p>
              </div>
              <h1>About us</h1>
            </div>
            <p className="text-center">
              InTransit brings you the most trustworthy and accomplished way of
              tracking and securing your package deliveries to and from anywhere
              around the globe.
            </p>
          </div>
        </div>

        <div className="container">
          <div className="three-section">
            <h4 className="text-center">
              One-stop-shop for all your package delivery needs
            </h4>
            <p className="text-center">
              With InTransit’s package tracking and order protection services,
              online deliveries become simple, secure, and spot-on time.
            </p>

            <div className="row mt-5">
              <div className="col-md-4">
                <div className="three-desc">
                  <h5 className="sub-heading">Customer Satisfaction</h5>
                  <p>
                    Give your customers a grand post-purchase experience right
                    from the checkout to the final delivery
                  </p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="three-desc">
                  <h5 className="sub-heading">Live Tracking</h5>
                  <p>
                    Keep tabs on your delivery status from anywhere and anytime
                    with the simple yet effective interface
                  </p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="three-desc">
                  <h5 className="sub-heading">Secure Delivery</h5>
                  <p>
                    Premium package protection against issues theft, damage, or
                    wrong deliveries
                  </p>
                </div>
              </div>
            </div>
          </div>
          <AnimatedOnScroll animationIn="zoomInLeft" animationInDuration={1000}>
            <div className="client-number">
              <ul>
                <li>
                  <h2>40000+</h2>
                  <p>Happy Clients</p>
                </li>
                <li>
                  <h2>3500+</h2>
                  <p>Answered Issues</p>
                </li>
                <li>
                  <h2>10k+</h2>
                  <p>Positive Reviews</p>
                </li>
                <li>
                  <h2>50k+</h2>
                  <p>Daily Visitors</p>
                </li>
                <li>
                  <h2>15k+</h2>
                  <p>Pro Users</p>
                </li>
              </ul>
            </div>
          </AnimatedOnScroll>

          <div className="show-admin">
            <div className="row">
              <div className="col-lg-6">
                <AnimatedOnScroll
                  animationIn="slideInLeft"
                  animationInDuration={2000}
                >
                  <div className="show-img-admin">
                    <img src={AdminFirst} />
                  </div>
                </AnimatedOnScroll>
              </div>
              <div className="col-lg-6">
                <div className="show-admin-desc">
                  <h2>Live Tracking</h2>
                  <p>
                    Eliminate the hassle and issues of the package delivery
                    process with InTransit’s state-of-the-art Geo-fencing
                    tracking solution. Add exceptional value to your
                    post-purchase process through advanced tracking technology
                    delivered right into the hands of your end-user. Boost your
                    brand awareness and customer satisfaction to new heights and
                    achieve higher conversions in no time.
                  </p>

                  <a href="http://intransit-test.s3-website.ap-south-1.amazonaws.com/login?user=customer">
                    <button className="yellow-btn">Get Started</button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="show-admin">
            <div className="row">
              <div className="col-lg-6">
                <div className="show-track-desc">
                  <h2>Premium Protection</h2>
                  <p>
                    Secure your packages from being lost, stolen, or damaged
                    during transportation and delivery. Build a brand reputation
                    that is upheld by our reliable package insurance services.
                    Customers can also choose to purchase protection plans at
                    their end during the checkout process and can take advantage
                    of the service.
                  </p>
                  {/* <div className="admin-track-group">
                  <ul>
                    <li>Lorem ipsum dolor sit</li>
                    <li>Lorem ipsum dolor</li>
                    <li>Lorem ipsum</li>
                    <li>Lorem ipsum dolor sit</li>
                    <li>Lorem ipsum dolor</li>
                  </ul>
                  <div className="admin-track-sub">
                    <h4>Protect</h4>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod Ut enim ad minim veniam. Lorem ipsum dolor
                      sit amet adipisicing.
                    </p>
                  </div>
                </div> */}
                </div>
              </div>
              <div className="col-lg-6">
                <AnimatedOnScroll
                  animationIn="slideInRight"
                  animationInDuration={2000}
                >
                  <div className="show-img-admin">
                    <img src={AdminTrack} />
                  </div>
                </AnimatedOnScroll>
              </div>
            </div>
          </div>
        </div>

        <div className="about-section-banner">
          <div className="container">
            <div className="about-section-desc">
              <h2>Seamless Query Resolution</h2>
              <div className="desc-button-about">
                <p>
                  With InTransit, your customers will never have to go through
                  the long and frustrating process of getting their queries and
                  complaints resolved. We engage directly with your customers
                  during delivery and offer a seamless and convenient interface
                  for any disputes or query resolution.
                </p>
                <a href="http://intransit-test.s3-website.ap-south-1.amazonaws.com/login?user=customer">
                  <button className="yellow-btn">Get Started</button>
                </a>
              </div>
            </div>

            <AnimatedOnScroll animationIn="zoomInUp" animationInDuration={1000}>
              <div className="about-section-banner-img">
                <img src={OrderList} />
              </div>
            </AnimatedOnScroll>
          </div>
        </div>

        <div className="join-network">
          <h3>Join Our Network Now.</h3>
          <p>Use In-Transit to boost your customer experience.</p>
          <Link to="/contact"> <button className="yellow-btn">Contact Us Now</button></Link>
        </div>
      </div>
    </>
  );
};

export default About;
